type ModelCardSkeletonVariant = 'bots' | 'selector'

interface Props {
	variant?: ModelCardSkeletonVariant
	showRadio?: boolean
}

export default function ModelCardSkeleton({ variant = 'bots', showRadio = false }: Props) {
	const rootClassName = [
		'model-item',
		'model-item--skeleton',
		variant === 'selector' ? 'model-item--selector-skeleton' : '',
	]
		.filter(Boolean)
		.join(' ')

	return (
		<div className={rootClassName} aria-hidden="true">
			<span className="model-cost model-cost--skeleton">
				<span className="model-line-skeleton model-line-skeleton--cost" />
			</span>

			<span className="model-icon model-icon--skeleton">
				<span className="model-circle-skeleton" />
			</span>

			<div className="model-content">
				<div className="model-info">
					<span className="model-item-name">
						<span className="model-line-skeleton model-line-skeleton--title" />
					</span>

					<span className="model-item-desc">
						<span className="model-line-skeleton model-line-skeleton--desc" />
					</span>
				</div>

				<div className="model-statistic">
					<span className="model-statistic_user">
						<span className="model-line-skeleton model-line-skeleton--stat" />
					</span>

					<span>
						<span className="model-line-skeleton model-line-skeleton--stat model-line-skeleton--short" />
					</span>
				</div>
			</div>

			{showRadio && <span className="model-radio" />}
		</div>
	)
}
